import React from 'react'
import { Card } from '@/components/ui/card'
import { Button } from '@/components/ui/button'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null, errorInfo: null }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to console
    console.error('Error Boundary caught an error:', error, errorInfo)

    // You can also log the error to an error reporting service here
    this.setState({
      error: error,
      errorInfo: errorInfo
    })
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex flex-col items-center justify-center p-4">
          <Card className="w-full max-w-2xl p-8 border-0 shadow-lg bg-white">
            <div className="text-center space-y-4">
              <h2 className="text-2xl font-bold text-red-600">Something went wrong</h2>
              <p className="text-slate-600">
                The application encountered an unexpected error. Please try refreshing the page.
              </p>

              {/* Development mode - show error details */}
              {import.meta.env.DEV && (
                <div className="mt-6 p-4 bg-red-50 rounded-lg border border-red-200 text-left">
                  <h3 className="font-semibold text-red-800 mb-2">Error Details (Development Mode):</h3>
                  <div className="text-sm text-red-700 space-y-2">
                    <div>
                      <strong>Error:</strong> {this.state.error?.toString()}
                    </div>
                    <div>
                      <strong>Component Stack:</strong>
                      <pre className="mt-1 text-xs bg-red-100 p-2 rounded overflow-auto">
                        {this.state.errorInfo?.componentStack}
                      </pre>
                    </div>
                    <div>
                      <strong>Error Stack:</strong>
                      <pre className="mt-1 text-xs bg-red-100 p-2 rounded overflow-auto">
                        {this.state.error?.stack}
                      </pre>
                    </div>
                  </div>
                </div>
              )}

              <div className="flex gap-3 justify-center mt-6">
                <Button
                  onClick={() => window.location.reload()}
                >
                  Reload Page
                </Button>
                <Button
                  variant="outline"
                  onClick={() => this.setState({ hasError: false, error: null, errorInfo: null })}
                >
                  Try Again
                </Button>
              </div>
            </div>
          </Card>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
